export default __webpack_public_path__ + "static/media/Logo.d418bd8c.svg";